import {AxiosError} from 'axios';
import {useQuery} from 'react-query';
import {toast} from 'react-toastify';
import {useAuth} from '../../../context/authContext';
import {getProfile} from '../../../services/profile';

const useGetProfile = (guid: string, isUpdate?: boolean) => {
  const {login, user, update} = useAuth();
  const {
    data: profile,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['getProfile', guid],
    queryFn: getProfile,
    enabled: !!guid,
    onSuccess: data => {
      if (data && user && isUpdate) {
        update({
          farmer_profile: data?.farmer_profile,
          marrket_profile: data?.marrket_profile,
          supplier_profile: data?.supplier_profile,
        });
      } else if (data && user) {
        login(
          {
            ...user,
            profile: {
              farmer_profile: data?.farmer_profile,
              marrket_profile: data?.marrket_profile,
              supplier_profile: data?.supplier_profile,
            },
          },
          '/profile',
        );
      }
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {profile, isLoading, refetch};
};

export default useGetProfile;
